import { render, staticRenderFns } from "./LabProductItem.vue?vue&type=template&id=4a66053c"
import script from "./LabProductItem.vue?vue&type=script&lang=js"
export * from "./LabProductItem.vue?vue&type=script&lang=js"
import style0 from "./LabProductItem.vue?vue&type=style&index=0&id=4a66053c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports